// path: src/EndlessMode.js

import React, { useMemo } from "react";
import "./App.css";
import EndlessSetup from "./Components/endless/EndlessSetup";
import OverlayTopBar from "./Components/OverlayTopBar";
import AppFooter from "./Components/AppFooter";
import { loadStoryProgress } from "./utils/storyProgress";

const EndlessMode = ({
    progress: progressProp,
    onStartEndless,
    onBackHome,
    onHome,
    onProfile,
    onStore,
    onTreats,
    onLeaderboards,
    onPrivacyPolicy,
    onTermsOfService,
    storeUnlocked = false,
    treats = 0,
}) => {
    const progress = useMemo(() => {
        return progressProp || loadStoryProgress();
    }, [progressProp]);

    return (
        <div className="endlessModeScreen">
            <div className="endlessModeShell">
                <img
                    className="endlessModeScreen__art"
                    src={`${process.env.PUBLIC_URL}/images/endless-screen-bg-v2.jpg`}
                    alt=""
                    aria-hidden="true"
                    decoding="async"
                />
                <header className="storyModeOverlay storyModeOverlay--top">
                    <OverlayTopBar
                        onHome={onHome}
                        onProfile={onProfile}
                        onStore={onStore}
                        onTreats={onTreats}
                        onBack={onBackHome}
                        storeUnlocked={storeUnlocked}
                        treats={treats}
                    />
                    <div className="storyModeOverlay__titleRow">
                        <h1 className="impactFont storyModeTitle">Endless Mode</h1>
                        {typeof onLeaderboards === "function" ? (
                            <button
                                type="button"
                                className="endlessLeaderboardsLink"
                                onClick={onLeaderboards}
                            >
                                Leaderboards
                            </button>
                        ) : null}
                    </div>
                </header>

                <div className="endlessModeStack">
                    <EndlessSetup
                        progress={progress}
                        onStart={onStartEndless}
                    />
                </div>
                <AppFooter
                    variant="overlay"
                    onPrivacyPolicy={onPrivacyPolicy}
                    onTermsOfService={onTermsOfService}
                />
            </div>
        </div>
    );
};

export default EndlessMode;
